module.exports = __webpack_public_path__ + "static/img/fish17.1cc86f7.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/fish/jingdianfish/fish17.png
// module id = zhIs
// module chunks = 0